export type GroupableAccount = {
  id: string;
  companyId: string | null;
  memberCount: number;
};

export type AccountGroup<T extends GroupableAccount> = {
  companyId: string | null;
  isNoCompanyGroup: boolean;
  accounts: T[];
  accountCount: number;
  totalAffectedUsers: number;
  isDuplicateGroup: boolean;
};

const NO_COMPANY_KEY = "__no_company__";

export function groupAccountsByCompany<T extends GroupableAccount>(
  accounts: T[],
): AccountGroup<T>[] {
  const accountsByKey = new Map<string, T[]>();

  for (const account of accounts) {
    const key = account.companyId ?? NO_COMPANY_KEY;
    const existing = accountsByKey.get(key);
    if (existing) {
      existing.push(account);
    } else {
      accountsByKey.set(key, [account]);
    }
  }

  return Array.from(accountsByKey.entries()).map(([key, groupAccounts]) => {
    const isNoCompanyGroup = key === NO_COMPANY_KEY;
    return {
      companyId: isNoCompanyGroup ? null : key,
      isNoCompanyGroup,
      accounts: groupAccounts,
      accountCount: groupAccounts.length,
      totalAffectedUsers: groupAccounts.reduce((sum, account) => sum + account.memberCount, 0),
      isDuplicateGroup: !isNoCompanyGroup && groupAccounts.length > 1,
    };
  });
}
